module.exports = __webpack_public_path__ + "static/media/banner_front.b46178df.png";